import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Yusuf Yazıcı',
    role: 'Esnaf',
    content: "İzmit sanayisinde 45.000 TL ücret istendi kendileri 10.000 TL'ye aracımdaki arızayı tamir etti tamir süresince tüm aşamalarda bilgi verdiler şahsen çok memnun kaldım iyi esnaflar kazançları bereketli olsun",
    rating: 5
  }, {
    name: 'Osman Boz',
    role: 'Çiftlik Yöneticisi',
    content: 'Çok memnunum. Güven Dizel Pompa yıllardır çalışıyorum. Hiç bir sorun yaşamadım',
    rating: 5
  }, {
    name: 'Recep Gündoğdu',
    role: 'Lojistik Şirketi Sahibi',
    content: "İşinin ehli ve fiyatlar insanları üzmüyor. Gereği neyse yapan bir işletme. Direk tavsiye ediyorum",
    rating: 4
  }];
  return <section id="yorumlar" className="py-16 bg-gray-100" data-id="element-185">
      <div className="container mx-auto px-4" data-id="element-186">
        <div className="text-center mb-12" data-id="element-187">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-188">
            Müşteri Yorumları
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-189">
            Müşterilerimizin memnuniyeti bizim için en önemli referanstır. İşte
            bazı müşterilerimizin yorumları:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-190">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md" data-id="element-191">
              <div className="flex mb-4" data-id="element-192">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-5 h-5 ${i < testimonial.rating ? 'text-yellow-500' : 'text-gray-300'}`} fill={i < testimonial.rating ? 'currentColor' : 'none'} data-id="element-193" />)}
              </div>
              <p className="text-gray-600 mb-6 italic" data-id="element-194">
                "{testimonial.content}"
              </p>
              <div data-id="element-195">
                <p className="font-bold text-blue-900" data-id="element-196">{testimonial.name}</p>
                <p className="text-gray-500 text-sm" data-id="element-197">{testimonial.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}